var _g, _defs, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlikPayLater = function SvgBlikPayLater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82.9133,
    height: 20,
    viewBox: "0 0 82.9133 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blik_Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector",
    d: "M39.0564 0H2.48054C1.11868 0 0 1.1358 0 2.51852V17.4815C0 18.8642 1.11868 20 2.48054 20H39.0564C40.4183 20 41.5369 18.8642 41.5369 17.4815V2.51852C41.5856 1.1358 40.4669 0 39.0564 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_2",
    d: "M39.0563 19.7528H2.48046C1.26451 19.7528 0.291748 18.7651 0.291748 17.5306V2.51825C0.291748 1.28368 1.26451 0.296021 2.48046 0.296021H39.0563C40.2723 0.296021 41.245 1.28368 41.245 2.51825V17.4812C41.245 18.7158 40.2723 19.7528 39.0563 19.7528Z",
    fill: "url(#blik_paint0_linear_10540_150265)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "blik_Group_2",
    filter: "url(#blik_filter0_d_10540_150265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_3",
    d: "M16.2392 5.13137C16.2392 3.94253 15.2868 2.99146 14.0963 2.99146C12.9058 2.99146 11.9535 3.94253 11.9535 5.13137C11.9535 6.3202 12.9058 7.27126 14.0963 7.27126C15.2868 7.22376 16.2392 6.27264 16.2392 5.13137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_4",
    d: "M20.2867 3.65735H17.9058V17.0675H20.2867V3.65735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_5",
    d: "M24.7629 8.31738H22.3819V17.1148H24.7629V8.31738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_6",
    d: "M11.7629 8.2225C11.001 8.2225 10.2867 8.41275 9.62001 8.74562V3.65735H7.23907V12.6926C7.23907 15.1654 9.23907 17.1626 11.7153 17.1626C14.1914 17.1626 16.1914 15.1654 16.1914 12.6926C16.2391 10.2197 14.2391 8.2225 11.7629 8.2225ZM11.7629 14.88C10.5724 14.88 9.62001 13.9289 9.62001 12.7401C9.62001 11.5512 10.5724 10.6002 11.7629 10.6002C12.9534 10.6002 13.9058 11.5512 13.9058 12.7401C13.9058 13.9289 12.9534 14.88 11.7629 14.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_7",
    d: "M20.2867 3.65735H17.9058V17.0675H20.2867V3.65735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_8",
    d: "M24.7629 8.31738H22.3819V17.1148H24.7629V8.31738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_9",
    d: "M11.7629 8.2225C11.001 8.2225 10.2867 8.41275 9.62001 8.74562V3.65735H7.23907V12.6926C7.23907 15.1654 9.23907 17.1626 11.7153 17.1626C14.1914 17.1626 16.1914 15.1654 16.1914 12.6926C16.2391 10.2197 14.2391 8.2225 11.7629 8.2225ZM11.7629 14.88C10.5724 14.88 9.62001 13.9289 9.62001 12.7401C9.62001 11.5512 10.5724 10.6002 11.7629 10.6002C12.9534 10.6002 13.9058 11.5512 13.9058 12.7401C13.9058 13.9289 12.9534 14.88 11.7629 14.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_10",
    d: "M32.5724 17.1151H35.6199L31.9533 12.3597L35.2866 8.31762H32.5248L29.239 12.4072V3.65735H26.8581V17.1151H29.239V12.4072L32.5724 17.1151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_11",
    d: "M14.0963 7.27126C15.2798 7.27126 16.2392 6.3132 16.2392 5.13137C16.2392 3.94953 15.2798 2.99146 14.0963 2.99146C12.9128 2.99146 11.9535 3.94953 11.9535 5.13137C11.9535 6.3132 12.9128 7.27126 14.0963 7.27126Z",
    fill: "url(#blik_paint1_linear_10540_150265)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blik_filter0_d_10540_150265",
    x: 6.23907,
    y: 2.99146,
    width: 30.3809,
    height: 16.1712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10540_150265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10540_150265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blik_paint0_linear_10540_150265",
    x1: 20.7684,
    y1: 19.7283,
    x2: 20.7684,
    y2: 0.320861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3459,
    stopColor: "#3E3E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7508,
    stopColor: "#262624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blik_paint1_linear_10540_150265",
    x1: 12.5991,
    y1: 3.63624,
    x2: 15.6254,
    y2: 6.66664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E53212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95296"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.54 2.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l1_Vector",
    d: "M2.07413 0.0987688C2.46919 0.0987688 2.86425 0.14815 3.1605 0.246919C3.45681 0.345681 3.70375 0.493831 3.90125 0.641975C4.09882 0.790125 4.24694 1.03704 4.34569 1.23457C4.4445 1.48148 4.49388 1.7284 4.49388 1.97531C4.49388 2.27161 4.4445 2.51852 4.34569 2.76543C4.24694 3.01235 4.09882 3.20988 3.90125 3.40741C3.70375 3.60494 3.45681 3.70373 3.1605 3.80248C2.86425 3.90123 2.51857 3.9506 2.1235 3.9506H1.38275V5.92591H0V0.0987688H2.07413ZM2.07413 3.01235C2.41975 3.01235 2.66669 2.91358 2.81481 2.76543C2.963 2.61729 3.06175 2.37037 3.06175 2.07408C3.06175 1.92593 3.06175 1.82716 3.01238 1.7284C2.963 1.62963 2.91363 1.53087 2.81481 1.4321C2.71606 1.33334 2.61731 1.28396 2.51856 1.23457C2.37038 1.18519 2.22225 1.18519 2.07413 1.18519H1.38275V3.01235H2.07413ZM9.43213 4.88891V5.97529H5.92594V3.9506L5.23463 4.29629V3.35803C5.23463 3.25926 5.284 3.16049 5.38275 3.16049L5.92594 2.8642V0.0987688H7.30869V2.22223L8.642 1.58025V2.51852C8.642 2.66667 8.59263 2.71605 8.49388 2.76543L7.30869 3.35803V4.88891H9.43213ZM15.9509 5.97529H14.9134C14.8147 5.97529 14.7159 5.92591 14.6172 5.87654C14.5184 5.82716 14.4691 5.72841 14.4691 5.67904L14.1234 4.64197H11.9012L11.5556 5.67904C11.5062 5.77779 11.4568 5.82716 11.4074 5.87654C11.3581 5.92591 11.2593 5.97529 11.1111 5.97529H10.0741L12.3457 0.0987688H13.7284L15.9509 5.97529ZM13.8272 3.7531L13.284 2.17284C13.2346 2.07408 13.1852 1.97531 13.1358 1.82716C13.0864 1.67901 13.0371 1.53087 12.9877 1.38272C12.9383 1.53087 12.8889 1.67901 12.8396 1.82716C12.7901 1.97531 12.7408 2.07408 12.6914 2.17284L12.1482 3.7531H13.8272ZM20.7903 4.44447C20.8397 4.44447 20.8397 4.44447 20.8891 4.44447C20.9384 4.44447 20.9384 4.49385 20.9878 4.49385L21.5309 5.03704C21.2841 5.33335 20.9878 5.58023 20.6422 5.72841C20.2966 5.87654 19.8522 5.97529 19.3578 5.97529C18.9134 5.97529 18.5184 5.87654 18.1728 5.72841C17.8272 5.58023 17.5309 5.38272 17.2841 5.08641C17.0372 4.83954 16.8397 4.49385 16.7409 4.14816C16.5928 3.80247 16.5434 3.40741 16.5434 2.96297C16.5434 2.51852 16.5928 2.12346 16.7409 1.77778C16.8891 1.4321 17.0866 1.08642 17.3334 0.839506C17.5803 0.592594 17.8766 0.345681 18.2716 0.197531C18.6172 0.0493813 19.0122 0 19.4566 0C19.6541 0 19.9016 1.39698e-08 20.0991 0.0493875C20.2966 0.0987688 20.4941 0.14815 20.6422 0.197531C20.7903 0.246913 20.9878 0.345681 21.0866 0.444444C21.2347 0.543213 21.3334 0.641975 21.4816 0.740744L21.0372 1.33334C20.9878 1.38272 20.9878 1.38272 20.9384 1.4321C20.8891 1.48148 20.8397 1.48148 20.7903 1.48148C20.7409 1.48148 20.6916 1.48148 20.6422 1.4321C20.5928 1.38272 20.5434 1.38272 20.4941 1.33334C20.4447 1.28395 20.3953 1.28396 20.3459 1.23457C20.2966 1.18519 20.1978 1.18519 20.1484 1.13581C20.0991 1.08643 20.0003 1.08642 19.8522 1.03704C19.7528 1.03704 19.6047 0.987656 19.4566 0.987656C19.2097 0.987656 19.0122 1.03704 18.8641 1.13581C18.6666 1.23457 18.5184 1.33334 18.3703 1.48148C18.2222 1.62963 18.1234 1.82716 18.0741 2.07408C18.0247 2.32099 17.9753 2.56791 17.9753 2.8642C17.9753 3.16049 18.0247 3.40741 18.0741 3.65435C18.1728 3.90123 18.2716 4.09879 18.4197 4.24691C18.5678 4.39504 18.7159 4.54323 18.9134 4.5926C19.1109 4.69135 19.3084 4.74072 19.5059 4.74072C19.6047 4.74072 19.7528 4.74072 19.8522 4.74072C19.9509 4.74072 20.0497 4.69135 20.1484 4.69135C20.2472 4.64198 20.2966 4.64198 20.3953 4.5926C20.4941 4.54323 20.5434 4.49385 20.6422 4.39504C20.6916 4.34566 20.6916 4.34566 20.7409 4.34566C20.7903 4.34566 20.7409 4.44447 20.7903 4.44447ZM24.0991 1.18519V2.51852H25.9259V3.50617H24.0991V4.88891H26.5184V5.97529H26.1728C26.0741 6.02466 25.9753 6.12348 25.9259 6.17285C25.8766 6.2716 25.8272 6.37035 25.8272 6.46916C25.8272 6.51854 25.8272 6.56791 25.8766 6.61729C25.9259 6.66666 25.9753 6.66666 26.0247 6.66666C26.0741 6.66666 26.0741 6.66666 26.1234 6.66666H26.1728H26.2222C26.2222 6.66666 26.2222 6.66666 26.2716 6.66666C26.3209 6.66666 26.3703 6.71604 26.3703 6.76541L26.5678 7.20985C26.4691 7.25929 26.3703 7.30866 26.2222 7.35804C26.0741 7.40741 25.9259 7.40741 25.7778 7.40741C25.4816 7.40741 25.2841 7.35804 25.1359 7.25929C24.9878 7.16048 24.8891 7.01235 24.8891 6.81479C24.8891 6.66666 24.9384 6.51854 25.0372 6.41973C25.1359 6.32098 25.2841 6.17285 25.4816 6.02466H22.8147V0.0987688H26.5678V1.13581H24.0991V1.18519Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.3 12.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l2_Vector",
    d: "M2.02469 0C2.41975 0 2.81481 0.0493742 3.11112 0.148187C3.40744 0.246937 3.65431 0.395062 3.85188 0.54325C4.04938 0.691375 4.19756 0.938312 4.29631 1.13581C4.39506 1.33337 4.44444 1.62962 4.44444 1.87656C4.44444 2.17287 4.39506 2.41975 4.29631 2.66669C4.19756 2.91362 4.04938 3.11112 3.85188 3.30869C3.65431 3.50619 3.40744 3.60494 3.11112 3.70375C2.81481 3.8025 2.46912 3.85187 2.07406 3.85187H1.38275V5.82719H0V0H2.02469ZM2.02469 2.86419C2.37038 2.86419 2.61731 2.76544 2.76544 2.61731C2.91362 2.46912 3.01238 2.22225 3.01238 1.92594C3.01238 1.77781 3.01237 1.679 2.963 1.58025C2.91362 1.4815 2.86419 1.38275 2.76544 1.284C2.66669 1.18519 2.56794 1.13581 2.46912 1.08644C2.321 1.03706 2.17288 1.03706 2.02469 1.03706H1.33337V2.91362L2.02469 2.86419Z",
    fill: "url(#l2_paint0_linear_10540_150278)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l2_paint0_linear_10540_150278",
    x1: -0.003625,
    y1: 2.126,
    x2: 34.6122,
    y2: 2.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75396"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.53 10.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l3_Vector",
    d: "M5.97531 4.59262C5.97531 5.03706 5.92594 5.43213 5.77781 5.77781C5.62962 6.12344 5.43213 6.46913 5.18519 6.71606C4.93831 6.963 4.59263 7.20987 4.24694 7.35806C3.85188 7.50619 3.45681 7.60494 3.01238 7.60494C2.56794 7.60494 2.1235 7.50619 1.77782 7.35806C1.38275 7.20987 1.08644 7.01238 0.8395 6.71606C0.592625 6.46913 0.345688 6.12344 0.197563 5.77781C0.0493757 5.43213 0 5.03706 0 4.59262C0 4.14812 0.0493757 3.75313 0.197563 3.40744C0.345688 3.06175 0.54325 2.71606 0.8395 2.46912C1.08644 2.22225 1.43213 1.97531 1.77782 1.82719C2.17288 1.679 2.56794 1.58025 3.01238 1.58025C3.45681 1.58025 3.90125 1.679 4.24694 1.82719C4.642 1.97531 4.93831 2.17287 5.18519 2.46912C5.43213 2.71606 5.67906 3.06175 5.77781 3.40744C5.92594 3.75313 5.97531 4.14812 5.97531 4.59262ZM4.59263 4.59262C4.59263 4.29631 4.54325 4.04937 4.49388 3.8025C4.39506 3.55556 4.29631 3.35806 4.14819 3.20988C4 3.06175 3.85188 2.91356 3.65431 2.86419C3.45681 2.76544 3.20987 2.71606 2.963 2.71606C2.71606 2.71606 2.46913 2.76544 2.27163 2.86419C2.07407 2.963 1.87657 3.06175 1.77782 3.20988C1.62963 3.35806 1.53088 3.55556 1.43213 3.8025C1.33338 4.04937 1.33337 4.29631 1.33337 4.59262C1.33337 4.88887 1.38275 5.13581 1.43213 5.38275C1.53088 5.62963 1.62963 5.82719 1.77782 5.97531C1.92594 6.12344 2.07407 6.27162 2.27163 6.321C2.46913 6.41975 2.71606 6.46913 2.963 6.46913C3.20987 6.46913 3.45681 6.41975 3.65431 6.321C3.85188 6.22225 4.04938 6.12344 4.14819 5.97531C4.29631 5.82719 4.39506 5.62963 4.49388 5.38275C4.54325 5.13581 4.59263 4.88887 4.59263 4.59262ZM4.79012 0L3.50619 1.13581C3.45681 1.18519 3.45682 1.18519 3.40744 1.18519C3.35807 1.18519 3.35806 1.23456 3.30869 1.23456C3.25925 1.23456 3.25931 1.23456 3.20988 1.23456C3.1605 1.23456 3.11112 1.23456 3.11112 1.23456H2.22225L2.963 0.148126C3.01237 0.0987509 3.01238 0.0493753 3.06175 0.0493753C3.11113 2.93367e-07 3.11113 0 3.1605 0C3.20988 0 3.25925 0 3.30869 0C3.35806 0 3.40744 0 3.45681 0H4.79012Z",
    fill: "url(#l3_paint0_linear_10540_150262)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l3_paint0_linear_10540_150262",
    x1: -5.23819,
    y1: 3.805,
    x2: 29.3776,
    y2: 3.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75396"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.1 10.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l4_Vector",
    d: "M4.64219 2.17288C4.64219 2.22225 4.64218 2.321 4.59281 2.37038C4.54343 2.41975 4.54344 2.5185 4.49406 2.56794L1.72837 6.5185H4.54343V7.55556H0V7.01238C0 6.963 -3.28291e-06 6.91356 0.0493717 6.81481C0.0493717 6.76544 0.0987497 6.71606 0.148125 6.66669L2.91344 2.71606H0.246873V1.679H4.64219V2.17288ZM4.29656 0L3.01219 1.13581C2.96281 1.18519 2.96281 1.18519 2.91344 1.18519C2.86406 1.18519 2.86406 1.23456 2.81468 1.23456C2.76531 1.23456 2.76531 1.23456 2.71594 1.23456C2.66656 1.23456 2.61719 1.23456 2.61719 1.23456H1.679L2.41969 0.148126C2.46906 0.0987509 2.46906 0.0493753 2.51843 0.0493753C2.56781 2.93367e-07 2.56781 0 2.61719 0C2.66656 0 2.71594 0 2.76531 0C2.81469 0 2.86406 0 2.91344 0H4.29656Z",
    fill: "url(#l4_paint0_linear_10540_150261)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l4_paint0_linear_10540_150261",
    x1: -11.8061,
    y1: 3.805,
    x2: 22.8097,
    y2: 3.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75396"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.93 12.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l5_Vector",
    d: "M5.08625 0.0493753V5.92594H4.395C4.29625 5.92594 4.1975 5.92594 4.14813 5.87656C4.09875 5.82719 4 5.77781 3.95062 5.679L1.185 2.17287C1.185 2.27162 1.185 2.37037 1.185 2.46912C1.185 2.56794 1.185 2.66669 1.185 2.76544V5.92594H0V0.0493753H0.691252C0.740627 0.0493753 0.790001 0.0493753 0.839376 0.0493753C0.888751 0.0493753 0.938125 0.0493744 0.938125 0.0987494C0.9875 0.0987494 0.987503 0.148187 1.03688 0.148187C1.08625 0.197562 1.08625 0.197562 1.13563 0.246937L3.90125 3.75312C3.90125 3.65431 3.90125 3.55556 3.85188 3.40744C3.8025 3.25925 3.85188 3.20988 3.85188 3.11113V0L5.08625 0.0493753Z",
    fill: "url(#l5_paint0_linear_10540_150264)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l5_paint0_linear_10540_150264",
    x1: -17.6333,
    y1: 2.17537,
    x2: 16.9825,
    y2: 2.17537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75396"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.54 12.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l6_Vector",
    d: "M1.3825 5.82719H0V0H1.3825V5.82719Z",
    fill: "url(#l6_paint0_linear_10540_150259)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l6_paint0_linear_10540_150259",
    x1: -24.2508,
    y1: 2.126,
    x2: 10.365,
    y2: 2.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75396"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.46 12.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l7_Vector",
    d: "M1.33375 1.03706V2.41975H3.16062V3.40744H1.33375V4.79012H3.75313V5.82719H0V0H3.75313V1.03706H1.33375Z",
    fill: "url(#l7_paint0_linear_10540_150258)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l7_paint0_linear_10540_150258",
    x1: -27.164,
    y1: 2.126,
    x2: 7.45188,
    y2: 2.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75396"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.0 12.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l8_Vector",
    d: "M2.86437 3.75312C2.86437 4.09875 2.815 4.39506 2.76563 4.642C2.66688 4.88888 2.56812 5.13581 2.42 5.33337C2.27187 5.53087 2.025 5.679 1.77813 5.77781C1.53125 5.87656 1.235 5.92594 0.889378 5.92594C0.741253 5.92594 0.593119 5.92594 0.444994 5.92594C0.296869 5.92594 0.148125 5.87656 0 5.82719L0.0493717 5.03706C0.0493717 4.98769 0.0987497 4.88887 0.148125 4.88887C0.1975 4.88887 0.247501 4.8395 0.346251 4.8395C0.395626 4.8395 0.445 4.8395 0.494375 4.8395C0.54375 4.8395 0.642503 4.8395 0.741253 4.8395C0.889378 4.8395 0.988124 4.8395 1.08687 4.79012C1.18562 4.74075 1.28438 4.69137 1.33375 4.59262C1.38313 4.49381 1.4325 4.39506 1.48188 4.24694C1.53125 4.09875 1.53125 3.95062 1.53125 3.75312V0H2.91375V3.75312H2.86437Z",
    fill: "url(#l8_paint0_linear_10540_150257)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l8_paint0_linear_10540_150257",
    x1: -31.7071,
    y1: 2.17537,
    x2: 2.90875,
    y2: 2.17537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75396"
  }))))));
};
export default SvgBlikPayLater;